<div class="content">
	<mat-expansion-panel
		[expanded]="expanded"
		(afterExpand)="expanded = true"
	>
		<mat-expansion-panel-header>
			@if (!expanded) {
				<mat-panel-title>
					<button
						mat-button
						type="submit"
						class="btn btn-dark btn-lg"
						style="width: 600px"
					>
						<i
							class="fa fa-search"
							style="padding-right: 8px"
						></i>
						{{ "dealer.search.search" | translate }}
					</button>
				</mat-panel-title>
			}
		</mat-expansion-panel-header>

		<mat-card appearance="outlined">
			<section style="padding: 8px; width: 600px; max-width: 600px">
				<div class="example-container">
					<form
						class="example-container"
						[formGroup]="dealerSearchForm"
					>
						<mat-form-field floatLabel="auto">
							<input
								matInput
								formControlName="idDealer"
								type="text"
								[placeholder]="'dealer.search.dealerCode' | translate"
							/>
						</mat-form-field>

						<mat-form-field floatLabel="auto">
							<input
								matInput
								formControlName="businessName"
								[placeholder]="'dealer.search.businessName' | translate"
							/>
						</mat-form-field>

						<!-- <mat-form-field floatLabel="auto">
							<input
								matInput
								formControlName="username"
								[placeholder]="'dealer.search.username' | translate"
							>
						</mat-form-field> -->

						<mat-form-field>
							<mat-label>{{ "dealer.search.country" | translate }}</mat-label>
							<mat-select formControlName="country">
								<mat-option>-</mat-option>
								@for (market of markets; track market) {
									<mat-option [value]="market">
										{{ market | clkBizCT: "COUNTRY" }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>

						<mat-form-field floatLabel="auto">
							<input
								matInput
								formControlName="vatCode"
								[placeholder]="'dealer.search.vat' | translate"
							/>
						</mat-form-field>

						<!-- <mat-form-field floatLabel="auto">
							<input
								matInput
								[placeholder]="'dealer.search.area' | translate"
							>
						</mat-form-field> -->

						<button
							mat-button
							type="submit"
							[disabled]="!dealerSearchForm.valid"
							class="btn btn-dark btn-lg"
							(click)="search()"
						>
							<i
								class="fa fa-search"
								style="padding-right: 8px"
							></i>
							{{ "dealer.search.search" | translate }}
						</button>
					</form>
				</div>
			</section>
		</mat-card>
	</mat-expansion-panel>
</div>
